module.exports = __webpack_public_path__ + "img/formF1.21892f7c.svg";